import type { Accommodation } from '../types/AccommodationSearch'
import type { CampsiteResponse } from '../types/Campsite'

export const useCampsitePage = (
  siteData: CampsiteResponse | null | undefined
) => {
  const { t } = useI18n()

  const showMobileFilters = ref(false)
  const showAccommodationInfo = ref(false)
  const showAccommodationModal = ref(false)
  const showAccommodationDrawer = ref(false)
  const selectedAccommodation = ref<Accommodation>()

  const TabsMaxHeight = ref(200)

  const largeImages = siteData?.data.images.map((image) => {
    return {
      image: image.fullsize,
      alt: image.altText,
    }
  })

  const tabs = ref([
    { title: t('site-tabs.information'), id: 'description' },
    ...(siteData?.data.importantInfo.length
      ? [
          {
            title: t('site-tabs.importantInformation'),
            id: 'important-info',
          },
        ]
      : []),
    { title: t('site-tabs.facilities'), id: 'facilities' },
    ...(siteData?.data.reviews
      ? [{ title: t('site-tabs.reviews'), icon: 'thumb_up', id: 'reviews' }]
      : []),
  ])

  const handleDesktopAccommodationClick = (accommodation: Accommodation) => {
    selectedAccommodation.value = accommodation
    showAccommodationModal.value = true
  }

  const handleMobileAccommodationClick = (accommodation: Accommodation) => {
    selectedAccommodation.value = accommodation
    showAccommodationDrawer.value = true
  }

  return {
    tabs,
    TabsMaxHeight,
    largeImages,
    showMobileFilters,
    selectedAccommodation,
    showAccommodationInfo,
    showAccommodationDrawer,
    showAccommodationModal,
    handleDesktopAccommodationClick,
    handleMobileAccommodationClick,
  }
}
